var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1091 258.1",
    style: {
      enableBackground: "new 0 0 1091 258.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M201,149.4h24c1.1,9.9,5.3,18.1,21.7,18.1c11,0,18.3-6,18.3-14.7c0-8.8-4.6-11.9-20.9-14.4 c-28.3-3.7-40-12.2-40-33.6c0-18.9,15.8-33,40.3-33c24.9,0,39.5,11.1,41.5,33.1h-23.1c-1.5-10.1-7.4-14.7-18.4-14.7 s-16.6,5.1-16.6,12.5c0,7.9,3.6,11.6,20.6,14.1c26.8,3.4,40.6,10.7,40.6,33.6c0,19.7-16.1,35.3-42.3,35.3 C216.3,185.8,202.4,171.5,201,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.9,79.9c0-7,5.6-12.2,12.7-12.2c7.3,0,12.9,5.3,12.9,12.2c0,7-5.6,12.2-12.9,12.2 C309.5,92.1,303.9,86.8,303.9,79.9z M305.6,103.1h22.3v81h-22.3V103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.6,144.6v-1.2c0-25.5,18.1-42.1,41.7-42.1c20.9,0,39.5,12.2,39.5,41.2v6.2h-58.4 c0.6,13.5,7.9,21.2,20.1,21.2c10.4,0,15.5-4.5,16.9-11.3h21.2c-2.6,17.5-16.6,27.3-38.7,27.3 C361.4,185.8,343.6,170.4,343.6,144.6z M402.9,134.8c-0.8-12.2-7-18.1-17.7-18.1c-10.1,0-16.9,6.7-18.6,18.1H402.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M439.4,103.1h22.5v15.5c5.1-10.8,13-16.6,26.2-16.7v20.9c-16.6-0.2-26.2,5.3-26.2,20.8v40.6h-22.5 V103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M502.8,103.1h22.5v15.5c5.1-10.8,13-16.6,26.2-16.7v20.9c-16.6-0.2-26.2,5.3-26.2,20.8v40.6h-22.5 V103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M559.3,161.6c0-18.9,17.3-26,42.1-26h9.1v-3.3c0-9.6-2.9-14.9-13.2-14.9 c-8.8,0-12.9,4.5-13.8,11.5h-21.2c1.4-19.2,16.6-27.7,36.4-27.7s33.9,8.1,33.9,30v52.8h-21.8v-9.8c-4.6,6.5-11.8,11.5-24.5,11.5 C571.7,185.8,559.3,178.6,559.3,161.6z M610.5,155.7v-6.8h-8.7c-13,0-20.6,2.8-20.6,11.5c0,5.9,3.6,9.8,11.8,9.8 C602.9,170.1,610.5,164.7,610.5,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M688.3,73.3h39.6c26.2,0,42.7,10.7,42.7,33.6v0.6c0,16.7-9.8,25.5-22.8,29.4l29.3,47.1h-26.6 L724,141.3h-10.8v42.7h-24.9V73.3z M727.3,124.3c12.5,0,18.9-5.3,18.9-15.9v-0.6c0-11.3-6.8-15.2-18.9-15.2h-14.1v31.7H727.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M782.2,144.6v-1.2c0-25.5,18.1-42.1,41.7-42.1c20.9,0,39.5,12.2,39.5,41.2v6.2H805 c0.6,13.5,7.9,21.2,20.1,21.2c10.4,0,15.5-4.5,16.9-11.3h21.2c-2.6,17.5-16.6,27.3-38.7,27.3 C800.1,185.8,782.2,170.4,782.2,144.6z M841.6,134.8c-0.8-12.2-7-18.1-17.7-18.1c-10.1,0-16.9,6.7-18.6,18.1H841.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M881.5,160.1v-41h-10.4v-15.9h10.4V85.6h22.3v17.5h17V119h-17v39c0,6.5,3.3,9.6,9,9.6 c3.4,0,5.9-0.5,8.5-1.5v17.3c-3.1,1.1-7.6,2.2-13.6,2.2C890.6,185.6,881.5,176.9,881.5,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M932,161.6c0-18.9,17.3-26,42.1-26h9.1v-3.3c0-9.6-2.9-14.9-13.2-14.9c-8.8,0-12.9,4.5-13.8,11.5 h-21.2c1.4-19.2,16.6-27.7,36.4-27.7s33.9,8.1,33.9,30v52.8h-21.8v-9.8c-4.6,6.5-11.8,11.5-24.5,11.5 C944.4,185.8,932,178.6,932,161.6z M983.2,155.7v-6.8h-8.7c-13,0-20.6,2.8-20.6,11.5c0,5.9,3.6,9.8,11.8,9.8 C975.6,170.1,983.2,164.7,983.2,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1023.5,79.9c0-7,5.6-12.2,12.7-12.2c7.3,0,12.9,5.3,12.9,12.2c0,7-5.6,12.2-12.9,12.2 C1029.1,92.1,1023.5,86.8,1023.5,79.9z M1025.2,103.1h22.3v81h-22.3V103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1068.7,66.4h22.3v117.7h-22.3V66.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M156.8,84.9c-0.1,1.1-0.7,2.2-1.7,2.9L10.3,189.2l2.4-16.4l0,0c0.2-1,0.7-2,1.7-2.7L159.2,68.8 l-2.5,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M102.9,153.4c-0.1,1.1-0.7,2.2-1.7,2.9L5.1,223.7l2.4-16.4l0,0c0.2-1,0.7-2,1.7-2.7l96.1-67.3 l-2.5,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M97.8,187.8c-0.1,1.1-0.7,2.2-1.7,2.9L0,258.1l2.4-16.4l0,0c0.2-1,0.7-2,1.7-2.7l96.1-67.3 l-2.5,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M167.1,16.1c-0.1,1.1-0.7,2.2-1.7,2.9L69.3,86.3L71.8,70l0,0c0.2-1,0.7-2,1.7-2.7L169.6,0L167,16.6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M161.9,50.5c-0.1,1.1-0.7,2.2-1.7,2.9l-96.1,67.3l2.4-16.4l0,0c0.2-1,0.7-2,1.7-2.7l96.1-67.3 L161.9,51"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a727cb30dd226bbd7b55fbfa8a388b7a.svg";
export { ForwardRef as ReactComponent };